import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { TJsonQueryRequiredKeys, TJsonQueryOptionalKeys, TJsonQueryKeys } from '../../../packages/JsonQuery';

const COMMON_PROPERTIES: (TJsonQueryRequiredKeys | TJsonQueryOptionalKeys)[] = [
  '_type',
  'beds_count',
  'builders_ids',
  'builder',
  'building_status',
  'currency',
  'dates',
  'engine_version',
  'for_day',
  'geo',
  'kp_id',
  'object_type',
  'office_type',
  'price',
  'price_sm',
  'region',
  'room',
  'with_newobject',
];

const COMMON_PROPERTIES_SUBURBAN: (TJsonQueryRequiredKeys | TJsonQueryOptionalKeys)[] = [
  '_type',
  'beds_count',
  'building_status',
  'currency',
  'dates',
  'engine_version',
  'for_day',
  'from_developer',
  'geo',
  'kp_id',
  'object_type',
  'price',
  'price_sm',
  'region',
  'room',
  'site',
  'total_area',
  'village_mortgage_allowed',
  'with_newobject',
];

export const selectIsCommonFiltersSelected = createSelector(selectJsonQuery, jsonQuery => {
  const commonProperties = jsonQuery._type === 'suburbansale' ? COMMON_PROPERTIES_SUBURBAN : COMMON_PROPERTIES;

  return (Object.keys(jsonQuery) as TJsonQueryKeys[]).some(
    property => !commonProperties.includes(property) && jsonQuery[property] !== undefined,
  );
});
